(function($){
$(document).ready(function() {
    if ( $('.popinmessage').html() != undefined && $('.popinmessage').html().trim() != '' ) {
        $.popin.alert( {
            type: $('.popinmessage').data('type'),
            title: $('.popinmessage').data('title'),
            message: $('.popinmessage').html(),
            button: $('.popinmessage').data('button')
        });
    }

    $('.menu_annees').click(function() {
        $('.annees_homelies').addClass('open');
    })
    $('.menu_annees').hover(function() {
        $('.annees_homelies').toggleClass('open');
    })

    $('body').click(function(e){
        if (e.target != $('.menu_annees button')[0]){
            $('.annees_homelies').removeClass('open');
        }
    })

    var ok = false;
    var tl = $(".timeline .wrapper");
    var tlPrec = tl.find(".tl-prec");
    var tlSuiv = tl.find(".tl-suiv");
    var tlFirst = tl.find(".first");
    var evts = $('.homelie-container');
    var targetPrec, targetSuiv, moisMax, moisPrec, moisSuiv;
    var currentYear = $(".timeline").data('currentyear');
    var pageHomelie = $(".timeline").data('pagehomelie');
    var idPageHomelie = $(".timeline").data('idpagehomelie');
    var hauteurMenu = 0-$('.site-header').outerHeight()-100;
    initTimeline();

    tl.find('a').on('click', function(e){
        console.log("pageHomelie", pageHomelie);

        e.preventDefault();

        let type        = $(this).data('type');
        let url         = $(this).data('url');
        let permalien   = $(this).data('permalien');
        let moisCible   = $(this).data('mois');
        let moisCibleNum = 1*moisCible.substr(3);
        let target      = $(this).data('url');

        moisPrec = (moisCibleNum>1) ? moisCibleNum-1 : 1;
        moisSuiv = (moisCibleNum<moisMax) ? moisCibleNum+1 : moisMax;
        setPrecSuiv();

        if(pageHomelie==1 && type=="jour")
          window.location.href=permalien;
        else {
          evts.find('.homelie').parent().removeClass("hover");
          $(target).parent().addClass('hover');

        if(type="jour") {
          $('.lien-timeline').removeClass("selected");
          $( this ).addClass('selected');
        }
          tl.scrollTo(moisCible, 400, {offset: -45});
          $(window).scrollTo(target, 400, {offset: hauteurMenu, axis:'y'});
        }
    });

    // $('.homelie').each(function(){
    //     let down, up,
    //         link = $(this).find('h2 a');
    //     $(this).on('mouseover', function(){
    //       evts.find('.homelie').parent().removeClass("hover");
    //     });
    //     if (link.length == 0) return false;
    //     $(this).on('mousedown', function(){
    //         down = +new Date();
    //     });
    //     $(this).on('mouseup', function(){
    //         up = +new Date();
    //         if ((up - down) < 200) {
    //             link[0].click();
    //         }
    //     })
    // })

    // $('.bloc-home:not(.bloc-actus), .bloc-actu').each(function(){
    //     let down, up,
    //         link = $(this).find('.bloc-link');
    //     if (link.length == 0) return false;

    //     $(this).on('mousedown', function(){
    //         down = +new Date();
    //     });
    //     $(this).on('mouseup', function(){
    //         up = +new Date();
    //         if ((up - down) < 200) {
    //             link[0].click();
    //         }
    //     })
    // })

    function initTimeline() {

      if(idPageHomelie>0) {


        var displayedWidth = $('.timeline').outerWidth()-90;
        var totalWidth = 0,
            im = 1,
            moisWidth = new Array();
        $('.timeline .annee .mois').each(function( index ) {
          moisWidth[im] = $(this).outerWidth();
          totalWidth += moisWidth[im++];
        });

        moisMax = (im-1);
        moisGauche = $("#lien-timeline"+idPageHomelie).data('mois').substr(3);
        moisPrec = (moisGauche>1) ? moisGauche-1 : 1;
        moisSuiv = (moisGauche<moisMax) ? moisGauche+1 : moisMax;
        tl.scrollTo('#m-'+moisGauche, 400, {offset: -45});

        $("#lien-timeline"+idPageHomelie).addClass('selected');

      } else if(currentYear==1) {

        var displayedWidth = $('.timeline').outerWidth()-90;
        var totalWidth = 0,
            im = 1,
            moisWidth = new Array();
        $('.timeline .annee .mois').each(function( index ) {
          moisWidth[im] = $(this).outerWidth();
          totalWidth += moisWidth[im++];
        });

        moisMax = (im-1);

        var t = 0,
            trouve = false,
            m, moisGauche;

        moisWidth.reverse().map(function(a,b) {
          t += a;
          if(t>displayedWidth)
            trouve = true;
          if(trouve == false)
            moisGauche = moisMax-b;
        })

        moisPrec = (moisGauche>1) ? moisGauche-1 : 1;
        moisSuiv = (moisGauche<moisMax) ? moisGauche+1 : moisMax;
        tl.scrollTo('#m-'+moisGauche, 400, {offset: -45});

      } else {
        moisPrec = 1;
        moisSuiv = 2;
        moisMax = 12;
      }
      setPrecSuiv();
    }
    function setPrecSuiv(){
        tlPrec.data('mois','#m-'+moisPrec);
        tlPrec.data('url',$('#m-'+moisPrec+' a').first().data('url'));
        tlSuiv.data('mois','#m-'+moisSuiv);
        tlSuiv.data('url',$('#m-'+moisSuiv+' a').first().data('url'));
    }

  })
})(jQuery);
